<script lang="ts" setup>
  import { computed, toRefs } from 'vue'

  import type { EmployeeNotificationJsonldDefaultRead, NotificationGenericJsonldDefaultRead } from '@/api'

  interface Props {
    notification: EmployeeNotificationJsonldDefaultRead
  }

  const props = defineProps<Props>()
  const { notification } = toRefs(props)

  const data = computed(() => notification.value.data! as NotificationGenericJsonldDefaultRead)
</script>

<template>
  <div>
    <p class="text-sm font-semibold leading-6 text-gray-900">
      {{ data.message }}
    </p>
  </div>
</template>
